// Public Support & FAQ's page - accessible without authentication
// Renders the reusable SupportAndFaqs component in a standalone layout

import { Box, Container } from '@/ui';
import { SupportAndFaqs } from '@/features/supportFaqs';

function SupportAndFaqsPublic() {
  return (
    <Box data-testid="pages-public-support-and-faqs-public-container-action-1" sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      {/* Branded header */}
      <Box data-testid="pages-public-support-and-faqs-public-container-action-2"
        sx={{
          backgroundColor: '#fff',
          py: 1.5,
          px: 3,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box data-testid="pages-public-support-and-faqs-public-container-action-3"
          component="a"
          href="https://www.iehub.co.uk/"
          aria-label="Go to IE Hub website"
          sx={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
        >
          <Box data-testid="pages-public-support-and-faqs-public-container-action-4"
            component="img"
            src="/icons/logo.png"
            alt="IE Hub"
            sx={{ width: 86, height: 44, borderRadius: 1, cursor: 'pointer' }}
          />
        </Box>
      </Box>

      {/* Content — no auth, shows email instead of Contact support button */}
      <Container data-testid="pages-public-support-and-faqs-public-container-action-5" maxWidth="md" sx={{ py: 2 }}>
        <SupportAndFaqs isAuthenticated={false} />
      </Container>
    </Box>
  );
}

export default SupportAndFaqsPublic;
